import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Reducer from "./Components/Redux/Reducer";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: Reducer,
});

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// // git remote set-url origin https://maluchetan4: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@github.com/maluchetan4/AtmStox-Web.git


if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js")
      .then(() => console.log("PWA Ready"))
      .catch((err) => console.error("SW Error:", err));
  });
}
